<template>
  <v-card class="rounded-card card-shadow">
    <v-card-text class="text--primary pa-5">
      <v-row dense>
        <v-col cols="12" sm="4" lg="5">
          <span class="body-2 font-weight-bold">Cliente</span>
          <px-compra-dados-basicos-empresa class="body-1" :empresa="compra.company"/>
        </v-col>
        <v-col cols="12" sm="4" lg="5">
          <span class="body-2 font-weight-bold">Fornecedor</span>
          <px-compra-dados-basicos-empresa class="body-1" :empresa="compra.fornecedor"/>
        </v-col>
        <v-col cols="12" sm="4" lg="2">
          <span class="body-2 font-weight-bold">Resumo do pedido</span>
          <v-row dense no-gutters class="body-1">
            <v-col cols="6">
              Produtos:
            </v-col>
            <v-col cols="6">
              {{ compra.totalProdutos | currency }}
            </v-col>
            <v-col cols="6">
              Frete:
            </v-col>
            <v-col cols="6">
              {{ compra.valorFrete | currency }}
            </v-col>
            <template v-if="compra.valorAdicional">
              <v-col cols="6">
                Adicional:
              </v-col>
              <v-col cols="6">
                {{ compra.valorAdicional | currency }}
              </v-col>
            </template>
            <template v-if="compra.desconto">
              <v-col cols="6">
                Desconto:
              </v-col>
              <v-col cols="6">
                -{{ compra.desconto | currency }}
              </v-col>
            </template>
            <v-col cols="6" class="font-weight-bold">
              Total:
            </v-col>
            <v-col cols="6">
              <span class="text--primary--color font-weight-bold">
                {{ compra.total | currency }}
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row dense class="mt-5">
        <v-col cols="12" sm="4" lg="5">
          <span class="body-2 font-weight-bold">Forma de pagamento</span>
          <div class="body-1">
            <px-forma-pagamento-marketplace
              show-icon
              :modo-pagamento="compra.modoPagamento"
              :forma-pagamento="compra.formaPagamento"
              :prazo-pagamento="compra.prazoPagamento"/>
            <div class="text--primary--color" v-if="compra.modoPagamento">
              <span v-if="isPagamentoNaoGerar">
                Voce é responsável por providenciar o pagamento para o cliente.
              </span>
              <span v-else>
                <px-situacao-pagamento small
                                       :situacao="compra.situacaoPagamento"/>
              </span>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="4" lg="5">
          <span class="body-2 font-weight-bold">Finalidade da compra</span>
          <div class="body-1">
            <px-finalidade-compra-value :finalidade-compra="compra.finalidadeCompra"/>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-3" v-if="compra.finalidadeCompra">

        <v-col cols="12" sm="4" lg="5" v-if="compra.company.pessoa.emailFinanceiro">
          <span class="body-2 font-weight-bold">E-mail para envio de NFe</span>
          <div class="body-1">
            {{ compra.company.pessoa.emailFinanceiro }}
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4" lg="5" v-if="compra.observacao">
          <span class="body-2 font-weight-bold">Observações internas</span>
          <div class="body-1">
            {{ compra.observacao }}
          </div>
        </v-col>
        <v-col cols="12" sm="4" lg="5" v-if="compra.arquivos.length">
          <span class="body-1 font-weight-bold">Anexos</span>
          <div>
            <px-anexo-chip is-marketplace :files="compra.arquivos"
                           :download-base-path="downloadFilePath"/>
          </div>
        </v-col>
      </v-row>
      <px-compra-dados-basicos-timeline :compra="compra"/>
    </v-card-text>
  </v-card>
</template>

<script>
import { SituacaoPagamento } from 'px-business-components';
import CompraDadosBasicosEmpresa from './CompraDadosBasicosEmpresa.vue';
import CompraDadosBasicosTimeline from './CompraDadosBasicosTimeline.vue';

export default {
  props: {
    compra: Object,
  },
  computed: {
    downloadFilePath() {
      return `fornecedor/compras/${this.compra.id}/file`;
    },
    isPagamentoNaoGerar() {
      return this.compra.situacaoPagamento === SituacaoPagamento.keys.NAO_GERAR.key;
    },
  },
  components: {
    pxCompraDadosBasicosEmpresa: CompraDadosBasicosEmpresa,
    pxCompraDadosBasicosTimeline: CompraDadosBasicosTimeline,
  },
};
</script>
